<template>
  <b-modal ref="modal" hide-footer no-close-on-backdrop hide-header-close>
    <template #modal-title>
      <span v-if="isNextDeliverySurveyDate">
        {{ labels.nextDeliverySurveyDate }}
      </span>
      <span v-else>
        {{ labels.closedSurveyDate }}
      </span>
    </template>
    <div class="d-block pb-2">
      <div v-if="isNextDeliverySurveyDate">
        <p class="text-primary">
          {{ labels.startTitle }}
        </p>
        <b-container fluid>
          <b-row>
            <b-col sm="4">
              <b-form-input
                class="custom-survey-modal-input"
                type="date"
                v-model="launchConfiguration.start.date"
              >
              </b-form-input>
            </b-col>
            <b-col sm="4">
              <b-form-group class="mt-0">
                <b-form-select
                  class="custom-survey-modal-input"
                  size="lg"
                  required
                  v-model="launchConfiguration.start.time"
                >
                  <option
                    v-for="(hour, index) in availableHours"
                    :value="hour"
                    :key="`hour_${index}`"
                  >
                    {{ hour }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.time }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group class="mt-0">
                <b-form-select
                  class="custom-survey-modal-input"
                  size="lg"
                  required
                  v-model="launchConfiguration.start.timezone"
                >
                  <option
                    v-for="(timezone, index) in availableTimezones"
                    :value="timezone"
                    :key="`timezone_${index}`"
                  >
                    {{ timezone }}
                  </option>
                </b-form-select>
                <label class="custom-input-label">
                  {{ labels.timezone }}
                </label>
                <label class="mdi mdi-chevron-down select-icon"></label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div v-else>
        <p class="text-primary">{{ labels.endTitle }}:</p>
        <b-container fluid>
          <b-row>
            <b-col sm="4">
              <b-form-input
                class="custom-survey-modal-input"
                type="date"
                v-model="launchConfiguration.endDate"
              >
              </b-form-input>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <div class="footer pt-4">
      <b-button
        :disabled="
          isNextDeliverySurveyDate
            ? !launchConfiguration.start.date
            : !launchConfiguration.endDate
        "
        variant="secondary"
        class="float-right modal-btn"
        :title="labels.btn.save"
        @click="doLaunch()"
      >
        {{ labels.btn.save }}
      </b-button>
      <b-button
        variant="link"
        class="float-right text-transform-none modal-btn"
        :title="labels.btn.goBack"
        size="lg"
        @click="hide()"
      >
        {{ labels.btn.goBack }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  isNextDeliverySurveyDate: {
    type: Boolean,
  },
  launchConfigurationReference: {
    type: Object,
  },
}

export default {
  props,
  data() {
    return {
      launchConfiguration: {
        start: {
          date: null,
          time: null,
          timezone: null,
        },
        endDate: null,
      },
      availableHours: [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ],
      availableTimezones: [
        '+14:00',
        // '+13:45',
        '+13:00',
        '+12:00',
        '+11:00',
        // '+10:30',
        '+10:00',
        // '+09:30',
        '+09:00',
        // '+08:45',
        '+08:00',
        '+07:00',
        // '+06:30',
        '+06:00',
        // '+05:45',
        // '+05:30',
        '+05:00',
        // '+04:30',
        '+04:00',
        // '+03:30',
        '+03:00',
        '+02:00',
        '+01:00',
        '+00:00',
        '-01:00',
        '-02:00',
        '-03:00',
        // '-03:30',
        '-04:00',
        '-05:00',
        '-06:00',
        '-07:00',
        '-08:00',
        '-09:00',
        // '-09:30',
        '-10:00',
        '-11:00',
        '-12:00',
      ],
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component.customSurveys.create.modals.launch
    },
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    clearState() {
      this.launchConfiguration.start.date = null
      this.launchConfiguration.start.time = '08:00'
      this.launchConfiguration.start.timezone = '-03:00'
      this.launchConfiguration.endDate = null
    },
    doLaunch() {
      const configuration = JSON.parse(
        JSON.stringify(this.launchConfigurationReference)
      )
      if (this.isNextDeliverySurveyDate) {
        configuration.start = this.launchConfiguration.start
      } else {
        configuration.endDate = this.launchConfiguration.endDate
      }

      this.$emit('launchSurvey', configuration)
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.modal-btn {
  border-radius: 10px !important;
  min-width: 160px;
}

select,
input:valid:not(.empty) {
  &.custom-survey-modal-input {
    border-radius: 10px !important;
    background-color: map-get($theme-colors, 'white') !important;
    border-color: var(--gray07) !important;
    height: 48px;
  }
}

.send-survey-warning {
  border-radius: 10px !important;
  border-color: var(--gray07) !important;
  font-size: 14px !important;
}
</style>
